var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home mx-auto"},[_c('cabecera-web'),_c('ver-establecimientos')],1)}
var staticRenderFns = []

export { render, staticRenderFns }